// extracted by mini-css-extract-plugin
module.exports = {"main":"styles_main__1RKSD","header":"styles_header__PzBA9","content":"styles_content__1xJV7"};